'use strict';

const BaseView = require('components-framework/view/base.view');
const defaultViewPartial = require('./view/view.default');
const payWithGuaranteePartial = require('./view/view.pay.with.guarantee');

module.exports = BaseView.extend(Odigeo._.extend(defaultViewPartial, payWithGuaranteePartial));
